// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"206":"77ee62d6","295":"477ab051","483":"562e9001","610":"2f935134","813":"02a8b67e"}[chunkId] + ".chunk.css";
};